import { NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { DashboardComponent } from "../../features/dashboard/dashboard.component";
import { TileMenuComponent } from "../../features/tile-menu/tile-menu.component";
import { NewUiLandingComponent } from "./new-ui-landing.component";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  imports: [NgIf, DashboardComponent, TileMenuComponent],
})
export class LandingComponent extends NewUiLandingComponent {}
